import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AuthButton = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  
  if (!auth.isAuthenticated) {
    return (
      <Link className="btn btn-primary" to="/login">
        Login
      </Link>
    );
  }

  const logout = () => {
    auth.signout().then(() => navigate("/"));
  };

  return (
    <div className="text-black">
      Welcome! {auth.user.firstName} {" "}

      <button className="btn btn-primary" onClick={logout}>
        Logout
      </button>
    </div>
  );
};

export default AuthButton;